<template>
  <div style="padding: 20px">
    <el-form :inline="true" >
      <el-form-item>
       <el-text :value="currentUrl">{{currentUrl}}</el-text>
      </el-form-item>
      <el-form-item>
        <el-select v-model="address" clearable placeholder="端口号" filterable
                   style="width: 200px;">
          <el-option v-for="item in addressList" :key="item.value" :label="item.label" :value="item.value"/>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="openLinkWindow()" type="primary">打开终端</el-button>
      </el-form-item>
    </el-form>
  </div>

</template>

<script>

export default {
  name: "AutomaticTerminalApp",
  computed: {},
  components: {},
  provide() {
    return {
      $fn: {
        openLink: () => {
          this.openLinkWindow();
        }
      }
    }
  },
  data() {
    return {
      currentUrl: '',
      address: '',
      addressList:[]
    };
  },
  async created() {
    this.getCurrentUrl()
    this.addressList = await this.$http('mesMoldTerminalService.getAddress')
  },
  mounted() {

  },
  methods: {

    getCurrentUrl(){
      let url = window.location.origin;
      this.currentUrl = url + '#/automaticTerminal/';
    },

    openLinkWindow(){
      let newWindow = window.open(this.currentUrl + this.address,"_blank");
      this.address = ''
    },

  },
}
</script>

<style lang="less" scoped>


</style>